/**
 * Uma pergunta só: pode animar?
 *
 * Existem duas fontes — o sistema (`prefers-reduced-motion`) e a chave em Configurações —
 * e o que é animado em JavaScript não enxerga nenhuma das duas sozinho: `requestAnimationFrame`
 * não obedece media query, e o atributo do `<html>` só chega ao CSS. Por isso confete,
 * contador rolando e rolagem suave perguntam aqui.
 */

export function reducedMotion() {
  const asked = document.documentElement.getAttribute('data-motion') === 'reduced';
  return asked || !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}
